import type { FC } from 'react';
import { type Message, MessageType } from '@/types/message.types';
import {
  ContactFormMessage,
  type ContactFormMessageProps,
} from './ContactFormMessage';
import { DocMessage, type DocMessageProps } from './DocMessage';
import { FileMessage, type FileMessageProps } from './FileMessage';
import { LinkMessage, type LinkMessageProps } from './LinkMessage';
import { MediaMessage, type MediaMessageProps } from './MediaMessage';
import {
  QuickReplyBtnMessage,
  type QuickReplyBtnMessageProps,
} from './QuickReplyBtnMessage';
import { TextMessage, type TextMessageProps } from './TextMessage';

// Export all message components
export { TextMessage };
export { DocMessage };
export { MediaMessage };
export { LinkMessage };
export { QuickReplyBtnMessage };
export { ContactFormMessage };
export { FileMessage };

// Export all message components props
export type { TextMessageProps };
export type { DocMessageProps };
export type { MediaMessageProps };
export type { LinkMessageProps };
export type { QuickReplyBtnMessageProps };
export type { ContactFormMessageProps };
export type { FileMessageProps };

type AnyMessageComponent =
  | FC<TextMessageProps>
  | FC<DocMessageProps>
  | FC<MediaMessageProps>
  | FC<LinkMessageProps>
  | FC<QuickReplyBtnMessageProps>
  | FC<ContactFormMessageProps>
  | FC<FileMessageProps>;

/**
 * Factory function to get the appropriate message component
 * @param message - The type of message content
 * @returns The corresponding component
 */
export const getMessageComponent = (message: Message): AnyMessageComponent => {
  switch (message.messageType) {
    case MessageType.TEXT:
      return TextMessage;
    case MessageType.FILE:
      return FileMessage;
    // TODO: may need to remove this case
    case MessageType.LINK:
      return LinkMessage;
    case MessageType.INTERACTIVE:
      if (message.extendedMessagePayload?.extendedMessageType === 503) {
        return LinkMessage;
      }
      if (message.extendedMessagePayload?.extendedMessageType === 502) {
        return QuickReplyBtnMessage;
      }
      if (message.extendedMessagePayload?.extendedMessageType === 501) {
        return ContactFormMessage;
      }
      return TextMessage;
    default:
      return TextMessage;
  }
};
